/**
 * Checks if the current route is handled by the Pages Router (as opposed to the App Router).
 * This is determined by checking if the current pathname starts with any of the
 * appRouterPathPrefixes (which are typically used to identify App Router routes).
 *
 * @param pathname - The current pathname (e.g., from next/navigation's usePathname)
 * @param appRouterPathPrefixes - An array of path prefixes that identify App Router routes
 * @returns {boolean} - true if the route is handled by the Pages Router, false otherwise
 */

export function isPageRouter(
  pathname: string | null,
  appRouterPathPrefixes: string[],
): boolean {
  return !appRouterPathPrefixes.some((prefix) => pathname?.startsWith(prefix));
}
